import { Helmet } from "react-helmet-async";

const SITE_NAME = "BCH Networking";
const DEFAULT_DESCRIPTION = "BCH Networking is India's premier closed-network platform for verified business owners. Exchange referrals, attend bi-weekly meetings, track growth, and build meaningful connections through structured chapters across 3+ cities.";
const DEFAULT_OG_IMAGE = "https://customer-assets.emergentagent.com/job_b68f5d48-9358-4d0a-afc5-51cf7740066b/artifacts/uz62qvb6_1%20variation.png";
const SITE_URL = "https://bchnetworking.com";

export const SEO = ({ title, description, path, ogImage, noIndex = false, jsonLd }) => {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - Connect. Collaborate. Grow.`;
  const pageDescription = description || DEFAULT_DESCRIPTION;
  const pageImage = ogImage || DEFAULT_OG_IMAGE;
  const canonicalUrl = path ? `${SITE_URL}${path}` : SITE_URL;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={canonicalUrl} />
      <meta name="robots" content={noIndex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />

      {/* JSON-LD */}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
